// TODO: длинный файл, декомпозировать
import {
  RESET,

  CREATE_BLOCK,
  MOVE_BLOCK,
  DELETE_MEDIA,
  DELETE_BLOCK,
  DELETE_EMPTY_BLOCKS,
  CLEAN_UP_CONTENT,

  SET_VALUE,

  MERGE_BLOCK_DATA,
  SET_BLOCK_TYPE,
  SET_BLOCK_ACTIVE,
  SET_BLOCK_NOT_NEW,
} from './constants';

export function reset(content) {
  return {
    type: RESET,
    payload: { content },
  };
}

export function setReadOnly(value) {
  return {
    type: SET_VALUE,
    payload: {
      field: 'readOnly',
      value,
    },
  };
}

export function setForceUpdateTextBlocks(value) {
  return {
    type: SET_VALUE,
    payload: {
      field: 'forceUpdateTextBlocks',
      value,
    },
  };
}

export function createBlock(blockType, position, blockObject) {
  return {
    type: CREATE_BLOCK,
    payload: {
      blockType,
      position,
      blockObject,
    },
  };
}

export function moveBlock(currentPosition, newPosition) {
  return {
    type: MOVE_BLOCK,
    payload: {
      currentPosition,
      newPosition,
    },
  };
}

export function deleteMedia(key) {
  return {
    type: DELETE_MEDIA,
    payload: { key },
  };
}

export function mergeBlockData(key, data) {
  return {
    type: MERGE_BLOCK_DATA,
    payload: {
      key,
      data,
    },
  };
}

export function changeBlockType(key, blockType) {
  return {
    type: SET_BLOCK_TYPE,
    payload: {
      key,
      blockType,
    },
  };
}

export function deleteBlock(key) {
  return {
    type: DELETE_BLOCK,
    payload: { key },
  };
}

export function deleteEmptyBlocks() {
  return {
    type: DELETE_EMPTY_BLOCKS,
  };
}

export function cleanUpContent() {
  return {
    type: CLEAN_UP_CONTENT,
  };
}

export function setBlockActive(key) {
  return {
    type: SET_BLOCK_ACTIVE,
    payload: { key },
  };
}

export function setBlockNotNew(key) {
  return {
    type: SET_BLOCK_NOT_NEW,
    payload: { key },
  };
}
